import React, { useEffect, useRef, useState } from 'react';
import { Bubble, Button, Form, Icon, Modal } from 'tea-component';
import TopicSelect from '../../FilterCommon/widgets/TopicSelect';
import './index.scss';
import useFeedsUpdate from '@/pages/opinion/hooks/useFeedsUpdate';
import { getLocale, useIntl } from 'umi';
import { topicNoTitleLocale } from '../../FilterCommon/constants/topic';

const EditingModal = ({
  close,
  visible,
  originContent,
  filter,
  topics,
  topicList,
  translateTopicFunc,
  changeNewTopic,
}: any) => {
  const {
    logLoading,
    loading,
    submit,
    newValue,
    modifiedValue,
    logList,
    getLogList,
  } = useFeedsUpdate({
    defaultValue: topics.join('|'),
    oldValue: topics.join('|'),
    autoLoad: false,
    filter: { ...filter, type: 5 },
  });

  useEffect(() => {
    visible && getLogList();
  }, [visible]);

  const [selectedTopics, setSelectedTopics] = useState(topics.join('|'));

  const topicSelectValue = useRef({ topic: [] });
  useEffect(() => {
    const value = newValue
      .split('|')
      .map((item: string) => item?.toLocaleLowerCase?.())
      .filter(Boolean);

    topicSelectValue.current.topic = value;
  }, [newValue]);

  const { formatMessage } = useIntl();

  return (
    <Modal
      className="dbo-editing-modal dbo-feeds-editpopup"
      visible={visible}
      size={800}
      caption={formatMessage({ id: 'Topic Editing' })}
      onClose={() => close()}
    >
      <Modal.Body>
        <Form>
          <Form.Item
            className="dbo-feeds-editpopup-item"
            label={formatMessage({ id: 'Original Content' })}
          >
            <Form.Text className="dbo-feeds-editpopup-content">
              {originContent}
            </Form.Text>
          </Form.Item>

          <Form.Item
            className="dbo-feeds-editpopup-item"
            label={formatMessage({ id: 'Topic' })}
          >
            <div className="dbo-feeds-editpopup-item-topic">
                {logLoading ? (
                  <Icon type={'loading'} className="dbo-title-flex-icon" />
                ) : (
                  <TopicSelect
                    onChange={(_value: string, data) => {
                      setSelectedTopics(data?.value?.topic.join('|'));
                    }}
                    hasHeaderContent={false}
                    backAllLevel2Value
                    hasAllOptions={false}
                    languageTitle={topicNoTitleLocale}
                    unlabeledReviewsValue="unlabeled reviews"
                    defaultValue={topicSelectValue.current}
                    filterOptions={topicList}
                    lang={getLocale()}
                  />
                )}
            </div>
          </Form.Item>
          <Form.Item
            className="dbo-feeds-editpopup-item dbo-feeds-editpopup-historybox"
            label={formatMessage({ id: 'Editing History' })}
          >
            <Form.Text>
              <div className="dbo-feeds-editpopup-history">
                {logLoading ? (
                  <div style={{ textAlign: 'center' }}>
                    <Icon type="loading" />
                  </div>
                ) : logList.length === 0 ? (
                  <div style={{ textAlign: 'center' }}>
                    {formatMessage({ id: 'Not yet edited' })}
                  </div>
                ) : (
                  logList.map(
                    ({ editor, create_time, new_value }: any, index) => {
                      return (
                        <div
                          className="editpopup-history-item"
                          key={create_time + new_value}
                        >
                          <div className="editpopup-history-item-hd">
                            <span className="editpopup-history-name">
                              {editor}
                            </span>
                            <span className="editpopup-history-text">
                              {create_time}
                            </span>
                          </div>

                          <div className="editpopup-history-item-bd dbo-editing-flex">
                            {new_value?.split?.('|').map((t: string) => {
                              return (
                                <div className="dbo-editing-flex-item" key={t}>
                                  {translateTopicFunc?.(t) || t}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    },
                  )
                )}
              </div>
            </Form.Text>
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Bubble
          dark
          closeOnScroll
          content={
            modifiedValue === selectedTopics
              ? formatMessage({
                  id: 'Please modify before submitting',
                })
              : !selectedTopics
              ? formatMessage({ id: 'Please select an option' })
              : undefined
          }
        >
          <Button
            onClick={() => {
              submit(close, selectedTopics);
              changeNewTopic(selectedTopics);
            }}
            type="primary"
            disabled={modifiedValue === selectedTopics || !selectedTopics}
            loading={loading}
          >
            {formatMessage({ id: 'Confirm' })}
          </Button>
        </Bubble>
        <Button type="weak" disabled={loading} onClick={close}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditingModal;
